/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserContactValidateDto } from '../../models/user-contact-validate-dto';

export interface UserClientControllerSendCodeV1$Params {
      body: UserContactValidateDto
}

export function userClientControllerSendCodeV1(http: HttpClient, rootUrl: string, params: UserClientControllerSendCodeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'token'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, userClientControllerSendCodeV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'token'?: string;
      }>;
    })
  );
}

userClientControllerSendCodeV1.PATH = '/api/v1/users/client/code';
